import AuthCard from "./AuthCard.vue";
export default AuthCard;
